var locale = {
    placeholder: '请选择时间'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/zh_CN.js
// module id = 286
// module chunks = 0